import * as React from 'react';

const SvgReload = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.158 18.9173C12.4806 19.0403 12.8417 18.8785 12.9646 18.5559L13.9464 15.9803C14.0408 15.7325 13.9686 15.4521 13.7663 15.2808C13.564 15.1094 13.2755 15.0844 13.0467 15.2183C12.1526 15.7416 11.1122 16.0417 9.99967 16.0417C6.66295 16.0417 3.95801 13.3367 3.95801 9.99999C3.95801 8.89851 4.25221 7.86763 4.76589 6.97962C4.93873 6.68083 4.83663 6.2985 4.53784 6.12566C4.23905 5.95282 3.85672 6.05492 3.68389 6.35371C3.06311 7.42685 2.70801 8.6729 2.70801 9.99999C2.70801 14.0271 5.9726 17.2917 9.99967 17.2917C10.7818 17.2917 11.5358 17.1683 12.2429 16.9399L11.7966 18.1107C11.6737 18.4333 11.8355 18.7944 12.158 18.9173ZM15.4615 13.8743C15.7603 14.0472 16.1426 13.9451 16.3155 13.6463C16.9362 12.5731 17.2913 11.3271 17.2913 9.99999C17.2913 5.97292 14.0268 2.70833 9.99967 2.70833C9.2175 2.70833 8.4635 2.83168 7.75645 3.06007L8.20273 1.88927C8.32568 1.56673 8.16387 1.2056 7.84133 1.08265C7.51879 0.959705 7.15765 1.12151 7.03471 1.44405L6.05294 4.0197C5.95849 4.26747 6.03068 4.54787 6.23302 4.71924C6.43536 4.89061 6.72382 4.91565 6.95266 4.78171C7.84669 4.25844 8.88718 3.95833 9.99967 3.95833C13.3364 3.95833 16.0413 6.66327 16.0413 9.99999C16.0413 11.1015 15.7471 12.1324 15.2335 13.0204C15.0606 13.3192 15.1627 13.7015 15.4615 13.8743Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgReload;
